<script>
    import {Form} from '../../helpers/Form/Form'
    export default {
        props: ['userprop', 'loggedinprop', 'stripetoken', 'email', 'total'],
        data() {
            return {
                user: {
                    fiscal_file: {}
                },
                form: new Form({
                    id: Math.random(),
                    birthday: null,
                    datetime: null,
                    email: null,
                    course: null,
                    phone_number: null,
                    fiscal_file: {
                        email: null,
                        first_name: null,
                        last_name: null,
                        address: null,
                        zip: null,
                        municipality: null,
                        province: null,
                        state: 'ITALIA',
                        born_in: null,
                        fiscal_code: null,
                        day: null,
                        month: null,
                        year: null
                    },
                    paymentIntent: null,
                    is_for_this_user: 0
                }),
                formPay: new Form({
                    email: null,
                    pay_method: null,
                    i_payment: null,
                    p_intent: null,
                    total: 0,
                    email: null,
                }),
                stripe: {},
                isVisible: false,
                loading: false,
                isLoading: false,
                email_message: '',
                email_exists: false,
                cardElement: null,
                days: [
                    {value: undefined, text: 'Giorno'}
                ],
                loggedIn: false,
                months: [
                    {value: undefined, text: 'Mese'},
                    {value: 1, text: 'Gennaio'},
                    {value: 2, text: 'Febbraio'},
                    {value: 3, text: 'Marzo'},
                    {value: 4, text: 'Aprile'},
                    {value: 5, text: 'Maggio'},
                    {value: 6, text: 'Giugno'},
                    {value: 7, text: 'Luglio'},
                    {value: 8, text: 'Agosto'},
                    {value: 9, text: 'Settembre'},
                    {value: 10, text: 'Ottobre'},
                    {value: 11, text: 'Novembre'},
                    {value: 12, text: 'Dicembre'}
                ],
                years: [
                    {value: undefined, text: 'Anno'}
                ],
            }
        },
        mounted() {
            let self = this;
            this.loggedIn = this.loggedinprop;
            if (this.userprop) {
                this.$set(this, 'form', Object.assign(this.form, this.userprop))
            } else {
                this.$set(this.formPay, 'email', this.email)
                this.$set(this.form, 'email', this.email)
                this.$set(this.form.fiscal_file, 'email', this.email)
            }

            this.$set(this.form, 'course', this.getParameterByName('course_id'))
            this.$set(this.form, 'phone_number', this.getParameterByName('phone_number'))
            this.$set(this.form, 'datetime', this.getParameterByName('datetime'))
            this.$set(this.form.fiscal_file, 'first_name', this.getParameterByName('first_name'))
            this.$set(this.form.fiscal_file, 'last_name', this.getParameterByName('last_name'))

            if (this.loggedIn) {
                if (this.userprop.fiscal_file.born) {
                    var birthday = this.userprop.fiscal_file.born.split('-');
                    this.$set(this.form.fiscal_file, 'day', parseInt(birthday[2], 10));
                    this.$set(this.form.fiscal_file, 'month', parseInt(birthday[1], 10));
                    this.$set(this.form.fiscal_file, 'year', parseInt(birthday[0], 10));
                }
            } else {
                let birthday = this.getParameterByName('birthday')
                this.$set(this.form, 'birthday', birthday)

                var splitBirthday = this.form.birthday.split('-');
                this.$set(this.form.fiscal_file, 'day', parseInt(splitBirthday[2], 10));
                this.$set(this.form.fiscal_file, 'month', parseInt(splitBirthday[1], 10));
                this.$set(this.form.fiscal_file, 'year', parseInt(splitBirthday[0], 10));
            }

            this.$bus.$on('user_logged_in', (user) => {
                self.loggedIn = true;
                self.user = user;
                self.userprop = user;

                this.$set(this, 'form', Object.assign(this.form, user))
                this.$set(this.form.fiscal_file, 'is_for_this_user', 1)
                this.$set(this.formPay, 'email', user.email)

                var birthday = user.birthday.split('-');

                this.$set(this.form.fiscal_file, 'day', parseInt(birthday[2], 10))
                this.$set(this.form.fiscal_file, 'month', parseInt(birthday[1], 10))
                this.$set(this.form.fiscal_file, 'year', parseInt(birthday[0], 10))

                $('#log_section').hide()
            });

            document.addEventListener('DOMContentLoaded', (event) => {
                self.stripe.stripe = Stripe(self.stripetoken);
                self.stripe.elements = self.stripe.stripe.elements();

                var style = {
                    base: {
                        color: '#32325d',
                        fontFamily: '"Montserrat", sans-serif',
                        fontSmoothing: 'antialiased',
                        '::placeholder': {
                            color: '#aab7c4'
                        },
                        ':focus': {},
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                };

                // Create an instance of the card Element.
                self.stripe.card = self.stripe.elements.create('card', {style: style});

                // Add an instance of the card Element into the `card-element` <div>.
                self.stripe.card.mount('#card-element');

                self.stripe.card.addEventListener('change', function (event) {
                    var displayError = document.getElementById('card-errors');
                    if (event.error) {
                        displayError.textContent = event.error.message;
                    } else {
                        displayError.textContent = '';
                    }
                });
            });

            for (let i = 1; i <= 31; i++) {
                this.days.push({value: i, text: i});
            }
            for (let i = new Date().getFullYear(); i >= 1928; i--) {
                this.years.push({value: i, text: i});
            }
        },
        methods: {
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");

                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);

                if (!results) return null;
                if (!results[2]) return "";

                return decodeURIComponent(results[2].replace(/\+/g, " "));
            },
            getTypeButtonId(type) {
                return 'type_button_' + type.value
            },
            isSelected(type) {
                if (this.user.fiscal_file) {
                    if (this.user.fiscal_file.text == type.value) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            checkEmail() {
                var self = this;

                axios({
                    method: 'post',
                    url: '/checkEmail',
                    data: {
                        email: this.form.email,
                    }
                }).then((response) => {
                    if (response.data.exist) {
                        self.email_message = response.data.message;
                        self.email_exists = true;
                        return false
                    } else {
                        self.email_message = '';
                        self.email_exists = false;
                        return true;
                    }
                }).catch((error) => {
                    self.email_message = error.message;
                    self.email_exists = true;
                    return false
                    window.alerts.error("Si è verificato un errore, riprova");
                });
            },
            openLoginModal() {
                $('#login_modal').modal();
            },
            submitPayment() {
                let self = this;
                let form = self.form;
                self.stripe.stripe.createToken(self.stripe.card).then(function (result) {
                    if (result.token) {
                        if (result.error) {
                            // Inform the customer that there was an error.
                            var errorElement = document.getElementById('card-errors');
                            errorElement.textContent = result.error.message;
                        } else {
                            // Send the token to your server.
                            $('#spinner-modal').modal();
                            stripeTokenHandler(result.token);
                        }
                    }

                });

                function stripeTokenHandler(token) {
                    // Insert the token ID into the form so it gets submitted to the server
                    var hiddenInput = document.createElement('input');
                    hiddenInput.setAttribute('type', 'hidden');
                    hiddenInput.setAttribute('name', 'stripeToken');
                    hiddenInput.setAttribute('value', token.id);

                    form.appendChild(hiddenInput);
                    form.submit();
                    //self.$bus.$emit('start-spinner');
                    //App.blockUI("Stiamo validando il tuo pagamento");
                }
            },
            async confirm() {
                const cardHolderName = document.getElementById('card-holder-name');
                const cardButton = document.getElementById('card-button');
                const clientSecret = cardButton.dataset.secret;

                let self = this;
                $('#spinner-modal').modal();
                this.isLoading = true;

                try {
                    await this.form.submit('post', route('reservations.validate'))

                    if (!self.loggedIn && self.checkEmail()) {
                        $('#spinner-modal').modal('hide');
                        self.isLoading = false;
                        return
                    }

                    const { paymentMethod, error } = await self.stripe.stripe.createPaymentMethod(
                        'card',
                        self.stripe.card
                    )

                    if (error) {
                        // Display "error.message" to the user...
                        // console.log(error);
                        $('#spinner-modal').modal('hide');
                        self.isLoading = false;
                        window.alerts.error(error.message);
                    } else {
                        // The card has been verified successfully..
                        this.formPay.pay_method = paymentMethod.id;
                        this.formPay.total = this.total;
                        this.formPay.email = this.form.email;

                        this.formPay
                            .submit('post', route('payintent.create'), {}, true)
                            .then( async ({intent}) => {
                                if(intent.status == 'succeeded') {
                                    this.$set(this.form, 'paymentMethod', paymentMethod.id)
                                    this.$set(this.form, 'paymentIntent', intent.id)

                                    this.form
                                        .submit('post', route('reservations.postBuy'))
                                        .then(response => {
                                            $('#spinner-modal').modal('hide');
                                            this.isLoading = false;

                                            location.href = response.redirect
                                        })
                                } else {
                                    self.form.p_intent = intent.id
                                    $('#spinner-modal').modal('hide');
                                    const {paymentIntent, error} = await self.stripe.stripe.handleCardAction(
                                        intent.client_secret
                                    );
                                    if (error) {
                                    // The payment failed -- ask your customer for a new payment method.
                                        self.isLoading = false;
                                        window.alerts.error(error.message)
                                    } else {
                                        // The payment has succeeded.
                                        $('#spinner-modal').modal();
                                        this.$set(this.form, 'paymentIntent', paymentIntent.id)

                                        this.form
                                            .submit('post', route('reservations.postBuy'))
                                            .then(response => {
                                                $('#spinner-modal').modal('hide');
                                                this.isLoading = false;

                                                location.href = response.redirect
                                            })
                                    }
                                }
                            })
                            .catch(error => {
                                $('#spinner-modal').modal('hide');
                                self.isLoading = false;
                                window.alerts.error('Qualcosa è andato storto durante la verifica del pagamento!');
                            })
                    }
                } catch (e) {
                    $('#spinner-modal').modal('hide');
                    this.isLoading = false;

                    $('html,body').animate({ scrollTop: 0 }, 'fast')

                    window.alerts.error("Compila i dati segnati in rosso!")
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/reservation/ReservationFiscalFileForm.vue